import React, { useEffect, useState } from "react";

const STORAGE_KEY = "cookieConsent";

export default function CookieBanner({ onConsentChange }) {
  const [consent, setConsent] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      setConsent(stored);
      if (onConsentChange) onConsentChange(stored);
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, [onConsentChange]);

  const handleChoice = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setConsent(value);
    if (onConsentChange) onConsentChange(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        padding: "16px",
        background:
          "linear-gradient(135deg, rgba(10,10,12,0.98), rgba(22,24,40,0.98))",
        backdropFilter: "blur(8px)",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        color: "#fff",
      }}
    >
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <h3 style={{ margin: 0 }}>Cookies & Datenschutz</h3>
        <p style={{ fontSize: 14, marginTop: 8 }}>
          Wir verwenden Cookies für die technische Bereitstellung unserer
          Website. Weitere Cookies (Statistik, Analyse) setzen wir nur nach
          Zustimmung. Mehr Informationen in unserer{" "}
          <a
            href="/datenschutz.html"
            style={{ color: "#4cc3ff", textDecoration: "underline" }}
          >
            Datenschutzerklärung
          </a>
          .
        </p>

        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
          <button
            onClick={() => handleChoice("necessary")}
            style={{
              padding: "8px 14px",
              borderRadius: 30,
              background: "transparent",
              border: "1px solid rgba(255,255,255,0.3)",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Nur notwendige Cookies
          </button>

          <button
            onClick={() => handleChoice("all")}
            style={{
              padding: "8px 16px",
              borderRadius: 30,
              background:
                "linear-gradient(135deg, #5bffb5, #4cc3ff)",
              border: "none",
              color: "#000",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
